import * as Yup from 'yup';

export const DadosProcedimentoValidation = Yup.object().shape({
  procedimentoRealizado: Yup.mixed().nonNullable('Selecione o procedimento')
    .notOneOf([null], 'Selecione o procedimento')
    .typeError('Selecione o procedimento'),
  quantidade: Yup.string()
    .required('Digite a quantidade'),
  valorPago: Yup.string()
    .required('Digite o valor pago')
})
